<template>
    <div class="ownerSessionTimer">
        <div><strong>session: {{ currentTime }}s: {{ percentTime }}%</strong></div>
        <div><progress :value="currentTime" :max="maxTime"></progress></div>
    </div>
</template>

<script>
export default {
    name: 'SessionTimer',
    data() {
        return {
            // currentTime: sessionTime.time,
            // maxTime: sessionTime.max
        }
    },
    watch(){

    },
    computed: {
        currentTime: function(){ return this.$store.getters.getSessionTime.time; },
        maxTime: function(){ return this.$store.getters.getSessionTime.max; },
        percentTime: function(){ return Math.round((this.currentTime / this.maxTime) * 100); },
    },
}
</script>